<template>
  <div>
    <p>We're really sorry to see you go! Remember, you can come back any time. To help us get better, please tell us why you are cancelling your subscription:</p>
    <b-form-group>
      <h5>What made you cancel?</h5>
      <b-radio-group v-model="reason" :options="options" variant="primary" class="cancel-reasons" stacked />
    </b-form-group>
    <b-form-group>
      <h5>How can we improve?</h5>
      <b-form-textarea v-model="other" :rows="2" placeholder="(optional)" />
    </b-form-group>
    <b-form-group class="mb-0">
      <b-button variant="danger" @click="cancel()">Cancel Subscription</b-button>
      <b-button variant="link" @click="back()">I changed my mind</b-button>
    </b-form-group>
  </div>
</template>

<script>
const cancelOptions = [
  { text : 'No longer need the service', value: 'no_longer_use' },
  { text : 'Didn\'t work as expected', value: 'not_working' },
  { text : 'Too expensive for me', value: 'too_expensive' },
  { text : 'Use another service', value: 'other_service' },
  { text : 'Other', value: 'other' },
]

export default {
  name: 'Cancel',

  data(){
    return {
      options : cancelOptions,
      reason  : '',
      other   : '',
    }
  },

  methods: {
    back(){
      this.$emit('back')
    },

    cancel(){
      this.$emit('cancel', this.reason, this.other)
    },
  }
};
</script>

<style lang="scss">
.cancel-reasons {
  .custom-radio {
    margin: 0.25rem 0;
  }
}
</style>
